import { FC, useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import Image from 'next/legacy/image'
import DOMPurify from 'isomorphic-dompurify'
import Skeleton from 'react-loading-skeleton'
import clsx from 'clsx'

import CommentsCountGet from 'components/parts/comments-count-get/comments-count-get'
import LikeShare from 'components/parts/like-share/like-share'
import LikesGet from 'components/parts/like-get/like-get'
import CardSpeciality from 'components/cards/card-parts/card-speciality/card-speciality'
import ExtraField from './extra-field/extra-field'

import { actualText, GENDERS } from './utils'
import { postAxiosSingle } from 'pages/api/axios'
import { ImageData } from '../data'
import { IClinicCard } from 'constants/types/card.types'
import { originShare } from 'utils/analytics/other/share_material/share_material'
import { URL_LIST } from 'constants/url'

import commonStyles from 'styles/common/cards.module.scss'
import styles from './clinical-card.module.scss'

const ClinicalCard: FC<IClinicCard> = (props: IClinicCard) => {
  const {
    id,
    title,
    text,
    Specialities,
    isCasePage,
    age,
    gender,
    other_diseases,
    pills,
    checkup_results,
  } = props
  const [views, setViews] = useState('')
  const { asPath } = useRouter()

  useEffect(() => {
    const postViews = async () => {
      const data = {
        id: asPath,
      }
      const result = await postAxiosSingle(URL_LIST.VIEWS_COUNT, {}, data)
      setViews(result?.data?.views ? String(result?.data?.views) : '0')
    }
    isCasePage && postViews()
  }, [asPath])

  return (
    <>
      {isCasePage && title && (
        <p className={clsx(styles.nameMainCase)}>{title || <Skeleton width="100%" />}</p>
      )}
      <div className={clsx(styles.cardWrapper, { [styles.cardWrapperCasePage]: isCasePage })}>
        {!isCasePage && title && (
          <p className={clsx(styles.name)}>{title || <Skeleton width="100%" />}</p>
        )}
        {isCasePage && (
          <>
            <div className={styles.patientInfo}>
              {age && (
                <ExtraField
                  fieldName="Возраст пациента"
                  fieldValue={age}
                  modificator={styles.ageField}
                />
              )}
              {gender && <ExtraField fieldName="Пол" fieldValue={GENDERS[gender]} />}
            </div>
            {other_diseases && (
              <ExtraField fieldName="Сопутствующие заболевания" fieldValue={other_diseases} />
            )}
            {pills && (
              <ExtraField fieldName="Принимаемые лекарственные препараты" fieldValue={pills} />
            )}
            {checkup_results && (
              <ExtraField fieldName="Результаты обследований" fieldValue={checkup_results} />
            )}
          </>
        )}

        {text ? (
          <>
            <div
              className={clsx(commonStyles.subtitle, styles.text, {
                [styles.textCasePage]: isCasePage,
              })}
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(actualText({ text, isCasePage })),
              }}
            />
            {!isCasePage && <span className={styles.readMore}>Читать далее</span>}
          </>
        ) : (
          <Skeleton width="100%" count={4} />
        )}
        <div className={clsx(styles.bottom, { [styles.bottomCasePage]: isCasePage })}>
          <div className={clsx(styles.bottomLeft, { [styles.bottomLeftCasePage]: isCasePage })}>
            <CardSpeciality Specialities={Specialities} />
          </div>
          <div className={styles.bottomRight}>
            {!isCasePage ? (
              <>
                <div className={styles.bottomRightPart}>
                  <Image {...ImageData.comment} layout="fixed" />
                  <span className={styles.count}>
                    <CommentsCountGet materialId={id} materialType="clinicalCase" />
                  </span>
                </div>
                <div className={styles.bottomRightPart}>
                  <Image {...ImageData.like_grey} layout="fixed" />
                  <span className={styles.count}>
                    <LikesGet id={`/clinical-case/${id}`} />
                  </span>
                </div>
              </>
            ) : (
              <LikeShare
                AData={{ origin: originShare.CLINICALCASE }}
                modificator={styles.likeShareBlock}
              />
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default ClinicalCard
